import React from 'react';

const CheckboxQuestion = ({ question, answer, onAnswerChange, inputRef }) => {
  const hasOption = (optionId) => (answer || []).map(String).includes(String(optionId));

  const handleChange = (option, isChecked) => {
    const currentAnswers = answer || [];
    let newAnswers;
    
    if (isChecked) {
      newAnswers = [...currentAnswers, option.id];
    } else {
      newAnswers = currentAnswers.filter(a => a !== option.id);
    }
    
    onAnswerChange(question.id, newAnswers);
  };

  return (
    <div className="checkbox-question">
      <h3>{question.question}</h3>
      {question.questionImageUrl && (
        <img className="quiz-question-image" src={question.questionImageUrl} alt="Question" />
      )}
      <div className="options">
        {question.options.map((option, index) => (
          <label
            key={option.id}
            className={`option-label${hasOption(option.id) ? ' selected' : ''}`}
          >
            <input
              type="checkbox"
              value={option.id}
              checked={hasOption(option.id)}
              onChange={(e) => handleChange(option, e.target.checked)}
            />
            <span className="option-content">
              {option.imageUrl && (
                <img className="quiz-option-image" src={option.imageUrl} alt={`Option ${index + 1}`} />
              )}
              {option.text && <span>{option.text}</span>}
              {!option.text && !option.imageUrl && <span>{`Option ${index + 1}`}</span>}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxQuestion;
